import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
export function CTASection() {
  return <section className="py-24 bg-amber-500 relative overflow-hidden" data-id="element-211" data-mp="27hf5sn5w9l8f">
      {/* Abstract background shapes */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-212" data-mp="2cefb2vux6jyh">
        <div className="absolute -top-24 -right-24 w-96 h-96 bg-amber-400 rounded-full mix-blend-multiply filter blur-2xl opacity-70" data-id="element-213" data-mp="2hgecw1b0h8tb"></div>
        <div className="absolute -bottom-24 -left-24 w-96 h-96 bg-amber-600 rounded-full mix-blend-multiply filter blur-2xl opacity-70" data-id="element-214" data-mp="2qfhwd6e3bq8c"></div>
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-6 md:px-12 text-center" data-id="element-215" data-mp="2v6rm06zn2tk8">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-4xl md:text-6xl font-extrabold text-charcoal-950 mb-6 tracking-tight" data-id="element-216" data-mp="3049pviysuild">
          Ready to Take Back Control?
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="text-xl md:text-2xl text-charcoal-900 mb-10 font-medium" data-id="element-217" data-mp="1w6406s8o11zx">
          Understand your pain, build a clear plan, and get back to doing what
          you love. Book a free consultation to see how we can work together.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} data-id="element-218" data-mp="265l0sv928pp1">
          <a href="https://calendly.com/dylanmclean-mcleanphysicaltherapy/consult-call" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 bg-charcoal-950 hover:bg-charcoal-800 text-white px-8 py-4 rounded-full font-bold text-lg transition-all transform hover:scale-105 shadow-xl" data-id="element-219" data-mp="vz8gz90c92fk">
            Book a Free 20-Minute Consultation
            <ArrowRightIcon size={20} data-id="element-220" data-mp="d7fqbl8qrtb0" />
          </a>
        </motion.div>
      </div>
    </section>;
}